import React from 'react'
import Image from 'next/image'
import sberLogo from './sber.png' 

export const Sber = () => {
  return (
    <Image width={24} height={24} src={sberLogo} alt='Sber' className='min-w-[24px] min-h-[24px]' />
  )
}
